import React from 'react';
import { Link } from 'react-router-dom';
import MeshGradient from '../components/ui/MeshGradient';
import NoiseTexture from '../components/ui/NoiseTexture';
import LogoWithTesseract from '../components/ui/LogoWithTesseract';
import DownloadWindowsLink from '../components/ui/DownloadWindowsLink';
import './PublicHome.css';

/**
 * Logged-out website root. A product page, not a form.
 */
const PublicHome = () => (
  <div className="public-home">
    <MeshGradient />
    <NoiseTexture />

    <header className="public-home__bar">
      <span className="public-home__brand">fokus</span>
      <Link to="/auth/login" className="public-home__bar-link">
        Log in
      </Link>
    </header>

    <main className="public-home__hero">
      <LogoWithTesseract
        logoSrc={`${process.env.PUBLIC_URL}/images/fokusLogo.svg`}
        logoAlt="Fokus"
        size={168}
      />
      <h1 className="public-home__title">Fokus</h1>
      <p className="public-home__tagline">
        Campaigns, docs, and the room you share — one place.
      </p>
      <div className="public-home__cta">
        <DownloadWindowsLink variant="primary" />
        <p className="public-home__cta-note">Free to download. Sign in to use it.</p>
      </div>
      <div className="public-home__alt">
        <Link to="/auth/login">Log in</Link>
        <span aria-hidden="true">·</span>
        <Link to="/auth/register">Get started</Link>
      </div>
    </main>
  </div>
);

export default PublicHome;
